// import React from "react";
import hero from "../assets/Analysis-bro.png";
import one from '../assets/Business crisis-amico.png';
import two from '../assets/Finance-amico.png';
import three from '../assets/Money income-amico.png';
// import { Testimonials } from "../components/Testimonials";
import { Link } from "react-router-dom";
const Home = () => {
    const insights = [
      {
        img: one,
        title: "Market Watch",
        summary: "Stay updated with breaking financial news and market trends.",
      },
      {
        img: two,
        title: "Investment Strategies",
        summary: "Discover risk-free ways to grow your wealth with smart planning.",
      },
      {
        img: three,
        title: "Wealth Management",
        summary: "Optimize your savings and investments with expert tips.",
      },
    ];

  return (
    <>
      <section>
        <div className="py-5"></div>
        <div className="container py-4 ">
          <div className="row">
            <div className="col-md-6 d-flex justify-content-center align-items-center">
              <div>
                <p className="heading">
                    Invest.<br /> <span style={{ color: "#76ABAE" }}>Grow.</span> Succeed.
                </p>

                <p className="content py-2">
                Get expert insights, real-time market analysis, and investment strategies to maximize your wealth.
                </p>
                <Link to="/blog">
                <button className="btn btn-light rounded-pill px-4 py-2">
                Start Investing →
                </button>
                </Link>
              </div>
            </div>
            <div className="col-md-6">
              <img src={hero} alt="image" className="img-fluid w-100 pt-md-0 pt-5" />
            </div>
          </div>
        </div>
      </section>

      <div className="py-5"></div>

      <section>
        <div className="container p-4">
          <div className="row align-items-stretch">
            <p className="heading text-center">Smart Choices, <span style={{ color: "#76ABAE" }}>Big Wins!</span></p>

            <div className="py-5"></div>

            
              <div className="col-md-4 d-flex" >
                <div className="card text-center h-100 d-flex flex-column">
                    <div className="mx-auto">
                    <svg xmlns="http://www.w3.org/2000/svg" width="80" height="80" fill="#76ABAE" class="bi bi-bar-chart-line-fill" viewBox="0 0 16 16">
                    <path d="M11 2a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v12h.5a.5.5 0 0 1 0 1H.5a.5.5 0 0 1 0-1H1v-3a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v3h1V7a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v7h1z"/>
                    </svg>
                    </div>
                  <div className="card-body d-flex flex-column flex-grow-1">
                    <h5 className="card-title fs-4 mb-4">Deep Dive into Market Trends</h5>
                    <p className="card-text flex-grow-1 content">Stay ahead with expert-driven financial analysis, real-time updates, and AI-powered insights.</p>
                </div>
                </div>
              </div>
              <div className="col-md-4 d-flex" >
                <div className="card text-center h-100 d-flex flex-column">
                    <div className="mx-auto">
                    <svg xmlns="http://www.w3.org/2000/svg" width="80" height="80" fill="#76ABAE" class="bi bi-lightbulb-fill" viewBox="0 0 16 16">
                      <path d="M2 6a6 6 0 1 1 10.174 4.31c-.203.196-.359.4-.453.619l-.762 1.769A.5.5 0 0 1 10.5 13h-5a.5.5 0 0 1-.46-.302l-.761-1.77a2 2 0 0 0-.453-.618A5.98 5.98 0 0 1 2 6m3 8.5a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1l-.224.447a1 1 0 0 1-.894.553H6.618a1 1 0 0 1-.894-.553L5.5 15a.5.5 0 0 1-.5-.5"/>
                    </svg>
                    </div>
                  <div className="card-body d-flex flex-column flex-grow-1">
                    <h5 className="card-title fs-4 mb-4">Choose Smart, Win Big!</h5>
                    <p className="card-text flex-grow-1 content">Optimize your portfolio with data-backed investment plans.</p>
                </div>
                </div>
              </div>
              <div className="col-md-4 d-flex" >
                <div className="card text-center h-100 d-flex flex-column">
                    <div className="mx-auto">
                    <svg xmlns="http://www.w3.org/2000/svg" width="80" height="80" fill="#76ABAE"  class="bi bi-rocket-takeoff-fill" viewBox="0 0 16 16">
                    <path d="M12.17 9.53c2.307-2.592 3.278-4.684 3.641-6.218.21-.887.214-1.58.16-2.065a3.6 3.6 0 0 0-.108-.563 2 2 0 0 0-.078-.23V.453c-.073-.164-.168-.234-.352-.295a2 2 0 0 0-.16-.045 4 4 0 0 0-.57-.093c-.49-.044-1.19-.03-2.08.188-1.536.374-3.618 1.343-6.161 3.604l-2.4.238h-.006a2.55 2.55 0 0 0-1.524.734L.15 7.17a.512.512 0 0 0 .433.868l1.896-.271c.28-.04.592.013.955.132.232.076.437.16.655.248l.203.083c.196.816.66 1.58 1.275 2.195.613.614 1.376 1.08 2.191 1.277l.082.202c.089.218.173.424.249.657.118.363.172.676.132.956l-.271 1.9a.512.512 0 0 0 .867.433l2.382-2.386c.41-.41.668-.949.732-1.526zm.11-3.699c-.797.8-1.93.961-2.528.362-.598-.6-.436-1.733.361-2.532.798-.799 1.93-.96 2.528-.361s.437 1.732-.36 2.531Z"/>
                    <path d="M5.205 10.787a7.6 7.6 0 0 0 1.804 1.352c-1.118 1.007-4.929 2.028-5.054 1.903-.126-.127.737-4.189 1.839-5.18.346.69.837 1.35 1.411 1.925"/>
                  </svg>
                    </div>
                  <div className="card-body d-flex flex-column flex-grow-1">
                    <h5 className="card-title fs-4 mb-4">Plan Smart, Grow Fast</h5>
                    <p className="card-text flex-grow-1 content">Get personalized financial advice to maximize profits and secure your future.</p>
                </div>
                </div>
              </div>
          </div>
        </div>
      </section>

      <div className="py-5"></div>

      <section>
      <div className="container py-5">
      <p className="heading text-center">
        Insights. <span style={{ color: "#76ABAE" }}>Analyze.</span> Grow.
      </p>
      <div className="py-5"></div>
      <div className="row g-4">
        {insights.map((item, index) => (
          <div key={index} className="col-md-4">
            <div className="card border-0 text-center bg-black p-4 h-100 rounded-4 insight-card">
              <img src={item.img} alt="img" className="img-fluid p-5"/>
              <h5 className="fw-bold">{item.title}</h5>
              <p className="content">{item.summary}</p>
            </div>
          </div>
        ))}
      </div>
      <div className="text-center mt-5">
        <Link to="/blog"> 
        <button className="btn btn-light rounded-pill px-4 py-2">Read Insights →</button>
        </Link>
      </div>
    </div>
      </section>

      <div className="py-5"></div>

      {/* <section>
        <Testimonials/>
      </section> */}
    </>
  );
};

export default Home;
